import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { GeoContainer } from '../../containers/filters/GeoContainer';
import { IFilter } from '../../types/filters';

export const geo: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: GeoContainer,
};
